import VehicleStatus from "@/constants/vehicle-statuses";

const VehicleUtils = {
    /**
     * @param {Number} status
     * @return {*}
     */
    getStatusLabel(status) {
        return _.get(
            _.find(VehicleStatus, {
                value: status,
            }),
            'label'
        );
    },
    arrangeVehicleImages(images) {
        if (!images.length) {
            return;
        }
        let front_index = 0;
        _.forEach(images, (image, index) => {
            if (image.custom_properties.is_front) {
                front_index = index;
            }
        });
        _.move(images, front_index, 0);
    },
    getStatusClass(status) {
        switch (status) {
            case VehicleStatus.available.value:
                return 'text-success';
            case VehicleStatus.underOffer.value:
                return 'text-warning';
            case VehicleStatus.onHold.value:
                return 'text-danger';
            case VehicleStatus.offerAccepted.value:
                return 'text-primary';
            case VehicleStatus.sold.value:
                return 'text-info';
            default:
                return null
        }
    }
};

export default VehicleUtils
